import {DialogContent, styled} from "@mui/material";

export const ActionDialogContent = styled(DialogContent)(() => ({
    minHeight: '15rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
}));

export const HistoryDialogContent = styled('div')(() => {
    return {

    }
});
